<!-- =========================================================================================
  File Name: StudentView.vue
  Description: Student View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="student-view-tab-class">
  <!-- 교재정보 -->
  <div>
    <!-- <h5 class="mt-8 mb-2">교재정보</h5> -->
    <vs-table v-model="selectedBook" @selected="handleBook" :data="book" stripe>
      <template slot="thead">
        <vs-th>번호</vs-th>
        <!-- <vs-th>브랜드</vs-th> -->
        <vs-th>코스</vs-th>
        <vs-th>레벨</vs-th>
        <vs-th>교재명</vs-th>
        <vs-th>시작일</vs-th>
        <vs-th>학습일</vs-th>
        <vs-th>진도율</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <!-- <vs-td :data="data[indextr].brandName">
            {{ data[indextr].brandName }}
          </vs-td> -->
          <vs-td :data="indextr + 1">
              {{ indextr + 1 }}
            </vs-td>

          <vs-td :data="data[indextr].courseName">
            {{ data[indextr].courseName }}
          </vs-td>

          <vs-td :data="data[indextr].levelName">
            {{ data[indextr].levelName  }}
          </vs-td>

          <vs-td :data="data[indextr].bookName">
            {{ data[indextr].bookName }}
          </vs-td>

          <vs-td :data="data[indextr].assignDate">
            {{ data[indextr].assignDate.split(' ')[0] }}
          </vs-td>

          <vs-td :data="data[indextr].lastStudyDate">
            {{ displayLastStudyDate(data[indextr].lastStudyDate) }}
          </vs-td>

           <vs-td :data="data[indextr].bookName">
            {{ data[indextr].progress }}%
          </vs-td>

        </vs-tr>
      </template>

    </vs-table> 
  </div>

  <!-- 학습설계 Button -->
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="assign">학습설계</vs-button>
      </div>
    </div>
  </div>

  <vs-divider class="mt-4 mb-4"></vs-divider>

  <!-- 학습스케줄 -->
  <div v-if="selectedBook" class="mt-6">
    <div><p class="product-name font-medium">{{selectedBook.bookName}} ({{selectedBook.progress}}%)</p></div>
    <div class="mb-4">
      <div class="flex justify-between">
        <small class="text-grey">0%</small>
        <small class="text-grey">100%</small>
      </div>
      <vs-progress :percent="selectedBook.progress" class="block mt-1shadow-md"></vs-progress>
    </div>
    <vs-collapse type="border" accordion>
      <vs-collapse-item :key="index" v-for="(stepList, index) in scheduleList">
        <div slot="header">
          <div class="vx-row flex flex-wrap justify-between">
            <div class="vx-col flex w-1/2 h-12">
              <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current mr-1"/>
              <p class="mt-2">{{ displayUnitName(stepList.unit)}}</p>
            </div>
          </div>
        </div>

        <vs-table :data="stepList.schedule" stripe>
        <template slot="thead">
          <vs-th>순서</vs-th>
          <vs-th width="30%">Step</vs-th>
          <vs-th >학습진도</vs-th>
          <vs-th >진도율</vs-th>
          <vs-th ></vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ indextr + 1}}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.stepName }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.studyFinishedCount }}/{{ tr.menuCount }}</p>
              </vs-td>
              <vs-td>
                <vs-progress :percent="data[indextr].progress" :color="progressColor(data[indextr].progress)"  class="shadow-md" />
              </vs-td>

              <vs-td>
                <vs-chip  class="product-order-status" :color="progressColor(data[indextr].progress)">{{ progressText(data[indextr].progress)}}</vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      </vs-collapse-item>
    </vs-collapse> 
    </div>
  </div>
</template>

<script>
import { fetchData } from '@/api/module'

export default {
  data () {
    return {
      studentID : this.$route.params.studentID,
      book: [],
      history: [],
      selectedBook: null,
      scheduleList: []
    }
  },
  methods: {
    displayLastStudyDate (studyDate) {
      if (studyDate === null) return
      return studyDate.substring(0, 10)
    },
    handleBook (tr) {
      this.loadScheduleList(tr.bookCode)
    },
    assign () {
      this.$router.push(`/student/book-add/${this.studentID}`)
    },
    displayUnitName (unit) {
      if (unit === null) return
      return unit.replace('U', 'Unit ')
    },
    progressText (progress) {
      if (progress === 0) {
        return '학습전'
      } else if (progress === 100) {
        return '학습완료'
      } else {
        return '학습중'
      }
    },
    progressColor (progress) {
      if (progress === 0) {
        return 'danger'
      } else if (progress === 100) {
        return 'success'
      } else {
        return 'primary'
      }
    },
    arrangeData (scheduleList) {
      
      let unitCode = ''
      let stepList = new Array()
      const unitList = new Array()
      for (let i = 0; i < scheduleList.length; i++) {
        if (unitCode !== scheduleList[i].unitCode) {
          unitCode = scheduleList[i].unitCode
          if (stepList.length > 0) {
            unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
            stepList = new Array()
          }
          stepList.push(scheduleList[i])
        } else {
          stepList.push(scheduleList[i])
        }
      }

      if (stepList.length > 0) {
        unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
      }
      return unitList
    },
    async loadBook () {
      try {
        const dataBook = await fetchData(`student/${this.studentID}/book`, {studentID : this.studentID})
        this.book = dataBook.data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadScheduleList (bookCode) {
      try { 
        const params = {
          bookCode,
          userID: this.studentID
        }
        const ret = await fetchData('/study-contents/schedule', params)
        this.scheduleList = this.arrangeData(ret.data.list)
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async loadBookHistory () {
      try {
        const dataBookHistory = await fetchData(`student/${this.studentID}/book-history`, {studentID : this.studentID})
        // console.log(dataBookHistory.data.list)
        this.history = dataBookHistory.data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadBook()  
    this.loadBookHistory() 
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-student-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
